import { setAllCartData} from '../../redux/checkoutredux/actions/cartactions/fetchdirectActions'; 
import store from '../../redux/checkoutredux/store/checkoutStore.ts';  //Todo-ips änderung ts js
// SC_ManageData.js


const SC_ManageData = {





fetchDataDirect: async (allupdatedData) => { 

   // console.log("Set Loading true");
   
  
    try {
     
  
  
   // console.log("fetchAllDataDirect GO");
  
  
     //console.log("----- FETCH DATA RETURN -----",allupdatedData);
     //-------------------------------------------------------------------------------------------------------------
     //----------------------------------------  CART DATA  --------------------------------------------------------
     if (allupdatedData && allupdatedData.data && allupdatedData.data.productdata && Array.isArray(allupdatedData.data.productdata)) {
      //console.log("-<=>-<=>- #UPDATE - PRODUCTSSETTINGS -<=>-<=>-");
      
  
      const updatedProducts = allupdatedData;
      //console.log("UPDATE DATA 1111: ",updatedProducts);
     
     
      store.dispatch(setAllCartData(updatedProducts.data));
  
  
  
  
     }else if (allupdatedData && allupdatedData.data) {
      const updatedProducts = allupdatedData;
      //console.log("Set Products NULL");
      store.dispatch(setAllCartData(updatedProducts.data));
  
     
    }else{

      //console.log("HINWEIS: allupdatedData ist undefined oder enthält keine gültigen Daten.");
            
      // Dispatch mit leeren oder Standarddaten, um Absturz zu vermeiden
     // store.dispatch(setAllCartData(null)); // Setzt die Daten auf null

    }
  
  
  
  
  
  
    } catch (error) {
      console.error('Error fetching cart items:', error);
    //  setLoading(false);
    }
  },





  validateOrderbump: (orderbump, products) => {
    /*
    let doOrderbump = true;
  
    const productId = parseInt(orderbump[0]['ips-mb-ordebumps-offer-product'], 10);
    const displayofferfor = orderbump[0]['ips-mb-ordebumps-display-option'];

  
    //const isProductInCart = products.some((item) => item.id === productId || item.variationid === productId);
    const isProductInCart = products && products.some((item) => item.id === productId || item.variationid === productId);
    const excludedProducts = orderbump[0]['ips-mb-ordebumps-display-excludproducts'];
    const excludedCategories = orderbump[0]['ips-mb-ordebumps-display-excludecats'];
    const specificProducts = orderbump[0]['ips-mb-ordebumps-display-specproducts'];
    const specificCategorie = orderbump[0]['ips-mb-ordebumps-display-speccats'];

    //console.log("isProductInCart: ",isProductInCart);
    //console.log("excludedProducts: ",excludedProducts);
    //console.log("specificProducts: ",specificProducts);

    //ToDo Validate also the CartGate element and if checked dont show here orderbump instead ogf hidden with JS
    //ToDo MESSAGE in Cartgate: If checked, orderbumps in the sidecart will be hidden ...Don't show orderbumps if this validation element is in cart. See JS-Validation in    let noorderbumps_tmp = settingsbox[0]['ips-mb-cartgate-addon-noorderbump'];
  
    if (!isProductInCart){
      
     // -------------------------------------------------------------------------------------------------- 
      if(displayofferfor === 'spec_products'){ // ******************* SPECIFIC PRODUCT *******************
      
      if(excludedProducts || specificProducts){
  
  
      if(specificProducts){
        doOrderbump = SC_ManageData.isProductIncluded(specificProducts, products);
  
      }
      if(excludedProducts && doOrderbump){
        doOrderbump = !SC_ManageData.isProductIncluded(excludedProducts, products);
  
      }

      if(excludedCategories && doOrderbump){
        doOrderbump = !SC_ManageData.isCategorieIncluded(excludedCategories, products);
  
      }
      
    }else{
      doOrderbump = true;
  
    }

     // -------------------------------------------------------------------------------------------------- 
  }else if(displayofferfor === 'spec_categories'){      // ************* SPECIFIC CATEGORIE *******************



    if(excludedProducts || specificCategorie){



  
  
      if(specificCategorie){
        doOrderbump = SC_ManageData.isCategorieIncluded(specificCategorie, products);
  
      }
      if(excludedProducts && doOrderbump){
        doOrderbump = !SC_ManageData.isProductIncluded(excludedProducts, products);
  
      }

      if(excludedCategories && doOrderbump){
        doOrderbump = !SC_ManageData.isCategorieIncluded(excludedCategories, products);
  
      }

      
      
    }else{
      doOrderbump = true;
  
    }

  }else if(displayofferfor === 'all'){      // ************* All Products *******************



  if(excludedProducts || excludedCategories){





   
    if(excludedProducts){
      doOrderbump = !SC_ManageData.isProductIncluded(excludedProducts, products);

    }

    if(excludedCategories && doOrderbump){
      doOrderbump = !SC_ManageData.isCategorieIncluded(excludedCategories, products);

    }

    
    
  }else{
    doOrderbump = true;

  }

}


  
  
    }else{
      doOrderbump = false;
    }
  
    return doOrderbump;
  */
  },
  
  isProductIncluded: (searchProducts, cartItems) => {
    if (!searchProducts || !cartItems) {
      return false; // Wenn keine searchProdukte vorhanden sind oder kein Warenkorb vorhanden ist, ist der return false
    }
  
    return searchProducts.some((searchId) =>
      cartItems.some((cartItem) => cartItem.id.toString() === searchId)
    );
  },



  isCategorieIncluded: (searchCat, cartItems) => {
    if (!searchCat || !cartItems) {
      return false; // Wenn keine searchProdukte vorhanden sind oder kein Warenkorb vorhanden ist, ist der return false
    }
  
    return searchCat.some((searchId) =>
      cartItems.some((cartItem) => cartItem.allcategorieids.toString() === searchId)
    );
  },
  

        



  convertToEuro: (priceInCents) => {
    const euros = (priceInCents / 100).toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return euros;
  },


  manageMainCounter: (quantity, totalFormat, cartslider) => {
    const updateCartCountInDOM = (newAmount) => {
      // Überprüfen, ob newAmount 0 ist
      const isEmpty = newAmount === 0;
      const allCartCountElements = document.querySelectorAll('.ips-woo-sc-count');
      if (allCartCountElements && allCartCountElements.length > 0) {
        allCartCountElements.forEach((cartCountElement) => {
          cartCountElement.textContent = isEmpty ? "" : newAmount;
          cartCountElement.style.display = isEmpty ? 'none' : '';
        });
      }
    };

    const updateCartPriceInDOM = (newPrice) => {
      // Überprüfen, ob newAmount 0 ist
      const isEmpty = newPrice === 0;
    
      const allCartCountElements = document.querySelectorAll('.ips-woo-sc-subt');
    
      if (allCartCountElements && allCartCountElements.length > 0) {
        allCartCountElements.forEach((cartCountElement) => {
          cartCountElement.innerHTML = isEmpty ? "" : newPrice;
        });
      }
    };

    // Aufrufen der Funktionen basierend auf den Eingabeparametern
    if (cartslider && ((Array.isArray(quantity) && quantity.length > 0) || (typeof quantity === 'number' && quantity >= 0))) {
    //  console.log("Do cartupdate");
    //  console.log("Price: ",totalFormat);
    //  console.log("Quantity: ",quantity);
      updateCartCountInDOM(quantity);
      updateCartPriceInDOM(totalFormat);
    }
  }
};

export default SC_ManageData;